jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{ variant.id }}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });
});


// 1. Seleccionar el elemento div con el atributo data-value='hasta'
const miDiv = document.querySelector("div[data-value='hasta']");

// 2. Verificar si el elemento fue encontrado (buena práctica)
if (miDiv) {
  // 3. Ocultar el elemento cambiando su estilo 'display' a 'none'
  miDiv.style.display = 'none';
  console.log("Elemento div con data-value='hasta' ocultado.");
} else {
  console.log("No se encontró ningún div con data-value='hasta'.");
}